var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getRootLogger } from '@lucidlink/tscore';
import { useUserClient } from '@lucidlink/uicore';
import { broadcastMessage, useLucidSdk } from '#context';
import { CurrentProfileKeyFactory } from '#query-hooks';
export const usePasswordLogin = ({ onError, onSuccess, } = {}) => {
    _react_refresh_temp_1();
    const { windowId } = useUserClient();
    const queryClient = useQueryClient();
    const { lucidSdk } = useLucidSdk();
    const mutation = useMutation({
        mutationFn: async (loginParams) => {
            await lucidSdk.authenticationClient().login(loginParams);
        },
        onError: (e, { email }) => {
            if (typeof onError === 'function') {
                onError(e);
            }
            getRootLogger().error({ err: e, email }, 'Password login failed');
        },
        onSuccess: async (_, { email }) => {
            await queryClient.refetchQueries({
                queryKey: CurrentProfileKeyFactory.exact(),
                exact: true,
            });
            broadcastMessage({ type: 'login', payload: { windowId } });
            getRootLogger().info({ email }, 'Password login succeeded');
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        },
        networkMode: 'always',
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(usePasswordLogin, "3HFKzqNB8sLmRGPoENANDkebb60=", false, () => [useUserClient, useQueryClient, useLucidSdk, useMutation]);
